import {useGlobalKeyDown} from '@containers/hooks'
import {useProfileStore} from '../profile-store'

export const useRequestCreatedPopup = (): {close: () => void} => {
  const [, store] = useProfileStore()
  const close = store.closeChangeEmailPopup

  useGlobalKeyDown({escape: close})

  return {close}
}
